import ApiService from '@/services/ApiService';

export default class ParentsApiService extends ApiService {
    constructor() {
        super('parents');
    }
}
